import { useEffect, useState } from 'react';
import { StoneXRow } from '../../../../StoneX';
import { StoneXButton, StoneXTextField } from '../../../../StoneXMui';
import { BaseReportSettingsPageProps } from './types';

interface GenericReportSettingsPageProps extends BaseReportSettingsPageProps {
  description: string;
}

export default function GenericReportSettingsPage({ report, isSaving, onDeleteReport, onUpdateReport, description }: GenericReportSettingsPageProps) {
  const [reportName, setReportName] = useState<string>(report.reportName);

  useEffect(() => {
    setReportName(report.reportName);
  }, [report.reportName]);

  function onSave() {
    onUpdateReport({
      ...report,
      reportName: reportName.trim(),
    });
  }

  return (
    <div>
      <StoneXRow>
        <StoneXTextField value={reportName} label="Report Name" onUpdate={setReportName} />
      </StoneXRow>

      <StoneXRow>
        {description}
      </StoneXRow>

      <StoneXRow justify="end" marginDirection="top">
        <StoneXButton variant="outlined" onClick={() => onDeleteReport(report.customerReportId)}>Delete Report</StoneXButton>
        <StoneXButton isWorking={isSaving} onClick={onSave}>Save</StoneXButton>
      </StoneXRow>
    </div>
  );
}
